import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PPP_WOOFY: TStep[] = [
  {
    pageId: PageId.DOG_AGE_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.DOG_OWNER_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.TRAINING_COMMANDS_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.URGE_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.DOG_BREED_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.FACING_CHALLENGES_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.URGE_PROGRAM_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.FIX_BEHAVIOR_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.URGE_4_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.COMMANDS_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.PARENT_GOAL_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.TRAINING_PLACE_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.URGE_5_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.PREPARE_FLOW_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.EMAIL_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.CHAT_UPSELL_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.CHAT_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.ACCOUNT_WOOFY_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.DOWNLOAD_WOOFY_WOOFZ_PPP_WOOFY,
  },
  {
    pageId: PageId.DOWNLOAD_WOOFZ_PPP_WOOFY,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PPP_WOOFY.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PPP_WOOFY.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_WOOFZ_PPP_WOOFY,
  PageId.FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY,
  PageId.DOG_BREED_WOOFZ_PPP_WOOFY,
  PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY,
  PageId.FIX_BEHAVIOR_WOOFZ_PPP_WOOFY,
  PageId.PARENT_GOAL_WOOFZ_PPP_WOOFY,
  PageId.TRAINING_PLACE_WOOFZ_PPP_WOOFY,
  PageId.TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY,
]

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_WOOFZ_PPP_WOOFY,
  PageId.FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY,
  PageId.DOG_BREED_WOOFZ_PPP_WOOFY,
  PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY,
  PageId.FIX_BEHAVIOR_WOOFZ_PPP_WOOFY,
  PageId.PARENT_GOAL_WOOFZ_PPP_WOOFY,
  PageId.TRAINING_PLACE_WOOFZ_PPP_WOOFY,
  PageId.TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY,
]
